import React, { Component } from 'react'
import { inject, observer } from 'mobx-react';
import { observable } from 'mobx';
import Pagination from 'components/Pagination';
import Footer from '../Footer';
import { Alert, Intent } from '@blueprintjs/core';
import qs from 'qs';
import Toast from 'helpers/toaster';
import * as Schedule from 'components/Tables/ScheduleList';
import * as DataList from 'components/DataList';

@inject('store', 'jobStore', 'viewStore') @observer
class JobsTable extends Component {

  @observable isRestoreDialogVisible = false;
  @observable job;

  handleRestoreCancel() {
    this.isRestoreDialogVisible = false;
  }

  handleRestoreConfirm() {
    this.props.jobStore.restoreJob(this.job)
      .then(this.onSuccessfulRestoreJob.bind(this))
      .catch(this.onFailedRestoreJob.bind(this))
  }

  onSuccessfulRestoreJob(response) {
    Toast.show({ icon: 'thumbs-up', message: 'Job restore successfully!', intent: Intent.SUCCESS })
    this.job = null;
    this.isRestoreDialogVisible = false;
    this.props.jobStore.loadJobs();
  }

  onFailedRestoreJob(error) {
    this.isRestoreDialogVisible = false;
    Toast.show({ icon: 'warning-sign', message: 'Unable to restore job!', intent: Intent.DANGER })
  }

  onPaginationChange(newPage) {
    let {
      viewStore: {
        jobSearch
      }
    } = this.props;
    this.props.viewStore.jobSearch = {
      ...jobSearch,
      page: newPage
    };
    this.props.viewStore.jobs();
  }

  handleJobClick(event, job) {
    switch (event.label) {
      case 'Recover':
        this.isRestoreDialogVisible = true;
        this.job = job;
        break;
      default:
    }
  }

  render() {
    let {
      viewStore,
      jobStore,
      viewStore: {
        jobSearch,
        jobTab: {
          section
        }
      },
      jobStore: {
        jobs: {
          objects,
          meta
        }
      }
    } = this.props;

    if (objects.length === 0) {
      return (
        <Schedule.Empty
          noun="jobs"
          search={jobSearch}
          onClearFilters={() => { viewStore.clearJobFilters(); viewStore.jobs(); }}
          onWiden={() => { viewStore.widenJobDateRange(3); viewStore.jobs(); }}
        />
      );
    }

    const deleted = jobSearch.only_deleted;
    const columns = Schedule.jobColumns(deleted);
    const cards = Schedule.jobCards(deleted);

    return (
      <React.Fragment>
        <Footer>
          <div className="bp3-navbar-group responsive-pagination bp3-align-left">
            <Pagination
              value={meta.page}
              total={meta.total_pages}
              onChange={this.onPaginationChange.bind(this)}
            />
          </div>
        </Footer>
        <DataList.List
          columns={columns}
          cards={cards}
          minTableWidth={Schedule.MIN_TABLE_WIDTH}
          total={meta.total_records || objects.length}
          noun="jobs"
          note={DataList.sortNote(jobSearch.order)}
        >
          {objects.map((job) => {
            const attributes = job.attributes;
            const createdBy = attributes.created_by && attributes.created_by.full_name;
            const agreement = attributes.service_agreement && attributes.service_agreement.number;
            const project = attributes.project && attributes.project.name;
            return (
              <DataList.Row key={job.id} accent={Schedule.accentFor(attributes.service_type_color)}>
                <DataList.Cell area="when">
                  <Schedule.When start={attributes.start_date} end={attributes.end_date} />
                </DataList.Cell>
                <DataList.Cell area="number">
                  <Schedule.JobNumber
                    number={attributes.event_number}
                    link={`/dashboard/jobs/${attributes.id}/${section}`}
                    title={attributes.title}
                    serviceType={{ name: attributes.service_type_name, color: attributes.service_type_color }}
                  />
                </DataList.Cell>
                <DataList.Cell area="job">
                  <Schedule.JobTitle
                    title={attributes.title}
                    details={[
                      Schedule.poLabel(attributes.po_number),
                      agreement && `Agreement ${agreement}`,
                      project && `Project: ${project}`,
                    ]}
                  />
                </DataList.Cell>
                <DataList.Cell area="created">
                  <Schedule.Created date={attributes.created_at} by={createdBy} />
                </DataList.Cell>
                <DataList.Cell area="team">
                  <Schedule.Team assignments={attributes.assignments} />
                </DataList.Cell>
                <DataList.Cell area="client">
                  <Schedule.Client
                    name={attributes.client_name}
                    link={attributes.client && attributes.client.id
                      ? `/dashboard/clients/${attributes.client.id}?${qs.stringify(viewStore.clientShowSearch, { encode: false })}`
                      : null}
                    location={attributes.location}
                  />
                </DataList.Cell>
                <DataList.Cell area="billing">
                  <Schedule.Billing invoiced={attributes.status === 'invoiced'} />
                </DataList.Cell>
                <DataList.Cell area="priority">
                  <Schedule.Priority priority={attributes.priority} />
                </DataList.Cell>
                {deleted && (
                  <DataList.Cell area="deleted">
                    {attributes.deleted_at && (
                      <span className="dl-muted"><DataList.CardOnly>Deleted </DataList.CardOnly>{Schedule.shortDate(attributes.deleted_at)}</span>
                    )}
                  </DataList.Cell>
                )}
                {!deleted && (
                  <DataList.Cell area="actions">
                    <Schedule.EditJob
                      onEdit={() => jobStore.openEditJobDrawer(attributes.id, { reloadList: 'jobs' })}
                    />
                  </DataList.Cell>
                )}
                {deleted && (
                  <DataList.Cell area="actions">
                    {attributes.deleted_at && (
                      <DataList.Actions
                        items={[{ icon: 'history', label: 'Restore job', onClick: () => this.handleJobClick({ label: 'Recover' }, job) }]}
                      />
                    )}
                  </DataList.Cell>
                )}
              </DataList.Row>
            );
          })}
        </DataList.List>
        <Alert
          cancelButtonText="Cancel"
          confirmButtonText="Restore"
          icon="history"
          intent={Intent.PRIMARY}
          isOpen={this.isRestoreDialogVisible}
          loading={this.props.jobStore.requestingRestoreJob}
          onCancel={this.handleRestoreCancel.bind(this)}
          onConfirm={this.handleRestoreConfirm.bind(this)}
        >
          <p>
            Are you sure you want to Restore <b>{this.job && this.job.attributes.event_number}</b> job?
          </p>
        </Alert>
      </React.Fragment>
    )
  }
};

export default JobsTable;
